import { csvParse } from 'd3';
import { Treemap } from 'd3plus';

export const initTreemap = () => {
  let treeMapData;
  let colorIndex = 0;
  let treeMapDataSecond;
  const tooltipSettings = {
    titleStyle: {
      color: '#1D2328',
      'font-size': '12px',
      'font-weight': '600',
      'text-align': 'center',
      opacity: '0',
      visibility: 'hidden',
    },
    background() {
      return '#fff';
    },
    width() {
      return '120px';
    },
    body(d) {
      return d.SumOfTotalEquity;
    },
    bodyStyle: {
      color: '#1D2328',
      'font-size': '12px',
      'font-weight': '600',
      'text-align': 'center',
    },
    tbody: {
      0: {
        0() {
          return false;
        },
      },
    },
  };

  const nav = '.treemap-nav';
  let isInitSecondInstance = false;
  // have to use jQuery selector due to Slick slider dependencies
  // eslint-disable-next-line no-undef
  const sliderContainer = jQuery('.treemap-slider');
  const treeMapcontainer = document.querySelectorAll('.treemap-slide');
  const colors = [
    '#264C68',
    '#007395',
    '#34C8DB',
    '#567E9B',
    '#309ABA',
    '#87DEE9',
  ];

  const removePartOfData = (data, elIndex) => {
    data.splice(elIndex, 1);
  };

  const addColor = (arrayData, id) => {
    arrayData.map((item, index) => {
      if (colorIndex > 5) {
        colorIndex = 0;
      }
      item.SumOfTotalEquity = item[arrayData.columns[1]].replace(
        /[\s.,%]/g,
        '',
      );
      item.color = colors[colorIndex];
      colorIndex += 1;

      if (item[id] === 'Grand Total') {
        removePartOfData(arrayData, index);
      }

      // lint requires this
      return false;
    });
  };

  // Only proceed if treemap containers exist
  if (treeMapcontainer.length === 0) {
    return;
  }

  // Load first treemap data
  if (treeMapcontainer[0] && treeMapcontainer[0].dataset.src) {
    fetch(treeMapcontainer[0].dataset.src)
      .then((res) => res.text())
      .then((result) => {
        if (result) {
          treeMapData = csvParse(result);
          addColor(treeMapData, 'MSA');

          new Treemap()
            .data(treeMapData)
            .groupBy('MSA')
            .select(treeMapcontainer[0])
            .sum((d) => {
              return d.SumOfTotalEquity;
            })
            .legend(false)
            .color((d) => {
              if (d.color) {
                return d.color;
              }

              return '#1D2328';
            })
            .label((d) => {
              return `${d.MSA},`;
            })
            .shapeConfig({
              labelConfig: {
                fontColor() {
                  return '#fff';
                },
                fontMax: 18,
                verticalAlign: 'bottom',
              },
            })
            .tooltipConfig(tooltipSettings)
            .render();
        }
      });
  }

  // Load second treemap data if it exists
  if (treeMapcontainer[1] && treeMapcontainer[1].dataset.src) {
    fetch(treeMapcontainer[1].dataset.src)
      .then((res) => res.text())
      .then((result) => {
        if (result) {
          treeMapDataSecond = csvParse(result);
          addColor(treeMapDataSecond, 'Asset Type');

          new Treemap()
            .data(treeMapDataSecond)
            .groupBy('Asset Type')
            .select(treeMapcontainer[1])
            .sum((d) => {
              return d.SumOfTotalEquity;
            })
            .legend(false)
            .color((d) => {
              if (d.color) {
                return d.color;
              }

              return '#1D2328';
            })
            .label((d) => {
              return `${d['Asset Type']},`;
            })
            .shapeConfig({
              labelConfig: {
                fontColor() {
                  return '#fff';
                },
                fontMax: 18,
                verticalAlign: 'bottom',
              },
            })
            .tooltipConfig(tooltipSettings)
            .render();
        }
      });
  }

  // Initialize slider if multiple slides exist
  if (treeMapcontainer.length > 1) {
    sliderContainer.slick({
      arrows: true,
      prevArrow:
        "<button class='prev ocean-prev'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M6.24625 0L0.24625 6L6.24625 12L7.75 10.5L3.24625 6L7.75 1.5L6.24625 0Z' fill='white'/></svg></button>",
      nextArrow:
        "<button class='next ocean-right'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M1.75375 0L7.75375 6L1.75375 12L0.25 10.5L4.75375 6L0.25 1.5L1.75375 0Z' fill='white'/></svg></button>",
      dots: true,
      mobileFirst: true,
      slidesToShow: 1,
      infinite: false,
      appendArrows: nav,
      appendDots: nav,
    });

    sliderContainer.on('afterChange', (event, slick, currentSlide) => {
      if (currentSlide === 1 && !isInitSecondInstance) {
        window.scrollTo(0, window.scrollY + 1);
        isInitSecondInstance = true;
      }
    });
  }

  // Reset container widths
  // eslint-disable-next-line no-restricted-syntax
  for (const item of treeMapcontainer) {
    item.style.width = '';
  }
};
